
export enum EPageType {
    params = "params", //page with multi params in id - included in navbar,
    tabs = "tabs", //page with item id and multi child pages - not included in navbar
    item = "item" //page with item id without other params and child pages - not include in navbar
}
export interface SinglePageConfig {
    id?: string
    default?: boolean
    url?: string //usually the path name matches the page name. This parameter changes the name in the browser path
    text?: string //path to localization text
    component?: string
    componentPath?: string
    icon?: string
    type?: EPageType
    paramName?: string
    paramTabName?: string
    defaultTab?: string
    redirectTo?: string
    children?: SinglePageConfig[]
    dynamicChildren?: string //dynamic load data to render menu
    customClick?: string //name of React component after click over button
    noLink?: boolean
    noMenu?: boolean //deny visualization into navbar
}
export interface IPageConfig {
    rootUrl?: string
    pages: SinglePageConfig[]
}

const pageConfig: IPageConfig = {
    rootUrl: process.env.PUBLIC_URL?.replace(/^\//, ""),
    pages: [
        {
            "id": "home",
            "type": EPageType.tabs,
            "defaultTab": "info"
        },
        {
            "id": "notFound",
            "noLink": true
        },
        { "id": "vatSettings" },
        { "id": "vat" },
        { "id": "users" },
        {
            "id": "user",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "tenants" },
        { "id": "companies" },
        {
            "id": "company",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "recycleBin" },
        { "id": "vatCountries" },
        { "id": "securityGroups" },
        {
            "id": "securityGroup",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "contractsSection" },
        { "id": "settings" },
        {
            "id": "contracts",
            "dynamicChildren": "contractTemplates"
        }
        ,
        {
            "id": "contract",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        {
            "id": "customFields",
            "type": EPageType.tabs,
            "defaultTab": "contract",
        }
        ,
        {
            "id": "contractTemplates"
        }
        ,
        {
            "id": "gridCustomField",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        }
        ,
        {
            "id": "customField",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        {
            "id": "contractTemplate",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "filesAndFolders" },
        {
            "id": "folderContent",
            "type": EPageType.params,
            "paramName": "folderId",
            "component": "filesAndFolders",
            "noLink": true
        },
        { "id": "businessObjects" }
        ,
        {
            "id": "businessObject",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "parties" }
        ,
        {
            "id": "party",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "invoices" }
        ,
        { "id": "companies" },
        {
            "id": "invoice",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "timelines" },
        {
            "id": "timeline",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        { "id": "alerts" },
        {
            "id": "contractTypes"
        },
        {
            "id": "contractObjects"
        },
        {
            "id": "sync"
        },
        { "id": "drafts" } ,
        {
            "id": "draft",
            "type": EPageType.tabs,
            "paramName": "id",
            "defaultTab": "info"
        },
        {"id" : "quality"},
{"id" : "qualityControlRules"}
,
    {
        "id" : "qualityControlRule",
        "type": EPageType.tabs,
        "paramName": "id",
        "defaultTab": "info"
    },
{"id" : "qualityControlScores"}
,
    {
        "id" : "qualityControlScore",
        "type": EPageType.tabs,
        "paramName": "id",
        "defaultTab": "info"
    },
{"id" : "aiPrompts"},
{"id" : "logs"}
,
    {
        "id" : "log",
        "type": EPageType.tabs,
        "paramName": "id",
        "defaultTab": "info"
    }
],
}

export default pageConfig
